export default __webpack_public_path__ + "static/mobil-70-5d547b2ec9f4fc937b5f66fbd39e91fe.png";